import { render, staticRenderFns } from "./ModelEditDialog.vue?vue&type=template&id=823666f6"
import script from "./ModelEditDialog.vue?vue&type=script&lang=js"
export * from "./ModelEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports